import { render, staticRenderFns } from "./edutalk-breadcrumbs.vue?vue&type=template&id=6f7d8566"
import script from "./edutalk-breadcrumbs.vue?vue&type=script&lang=js"
export * from "./edutalk-breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports